export class ErrorPopUpModel {
  headerMessage: any;
  confirmIsDisplay: boolean;
  displayMessage: any;
  headerTitle: string;

}
